import { createCrudActions } from '../utils/crudGenerator';

const formatDeckPlayeds = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchDeckPlayeds,
    create: createDeckPlayed,
    update: updateDeckPlayed,
    delete: deleteDeckPlayeds
} = createCrudActions('DECKPLAYED', "Decks Jugado", formatDeckPlayeds);